module.exports = __webpack_public_path__ + "static/media/blockchain-news.43339e51.jpg";